import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import idx from 'idx';
import {
  setOfferNegotiationAction, advanceOfferNegotiation, fetchUnderNegotiation
} from 'entries/ducks';
import { fetchWrapupsIfNeeded } from 'project/ducks/wrapup';
import { OFFER_FEE } from 'entries/constants';
import NegotiationModal from 'common/components/modal/negotiation';

const mapStateToProps = (state) => {
  const { offerNegotiationAction, offerNegotiationEntry = {} } = state.entries;
  const currentValue = parseFloat(offerNegotiationEntry.offer_value || 0);
  const currentFee = currentValue * OFFER_FEE;
  const value = parseFloat(idx(state, _ => _.form.NegotiationModal.values.next_value) || 0);
  const fee = value * OFFER_FEE;

  return {
    action: offerNegotiationAction,
    entry: offerNegotiationEntry,
    currentTotal: currentValue + currentFee,
    total: value + fee,
    currentValue,
    currentFee,
    fee
  };
};

const mapDispatchToProps = dispatch => ({ dispatch });

const mergeProps = (stateProps, { dispatch }) => {
  const dispatchProps = bindActionCreators({
    onClose: partial(setOfferNegotiationAction, undefined, undefined),
    advanceRequest: partial(advanceOfferNegotiation, stateProps.entry.project),
    onDone: entry => (dispatch) => {
      /* fetch updated wrapups list if negotiation ended successfully */
      if (['client_accepted', 'creative_accepted'].includes(entry.offer_negotiation_status)) {
        dispatch(fetchWrapupsIfNeeded(stateProps.entry.project, true));
      }

      /* fetch updated list of entries under negotiation */
      dispatch(fetchUnderNegotiation(stateProps.entry.project));
    }
  }, dispatch);

  return {
    ...stateProps,
    ...dispatchProps
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(NegotiationModal);



// WEBPACK FOOTER //
// ./entries/containers/offer_negotiation_modal.js